// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator one_on_ones`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] =
    [] /* Generated file 👉 artifacts/one_on_ones-module-index.tsx-collection-dependencies-report-v2.json */
  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
